import Image from "next/image";
import { Vehicle } from "../../graphql/generated/graphql";
import { formatPrice } from "../../utils/formatters";
import ConnectStatusBadge from "./ConnectStatusBadge";
import {
  calculateFeeAmount,
  isInactive,
  isUnauthorized,
} from "../../utils/connect";
import { useSession } from "next-auth/react";
import ShareSection from "../ShareSection";

export default function ConnectVehicleBanner({
  vehicle,
}: {
  vehicle: Vehicle;
}) {
  const { status: sessionStatus, data: sessionData } = useSession();
  const { user: currentUser } = sessionData || {};

  if (
    sessionStatus === "unauthenticated" || // Move this to the functions below
    sessionStatus === "loading" || // Move this to the functions below
    isUnauthorized(currentUser) ||
    isInactive(currentUser) ||
    isUnauthorized(vehicle?.user) ||
    isInactive(vehicle?.user)
  ) {
    return null;
  }

  const { price, minPrice, totalFee, sharedFee, negotiationStatus, currency } =
    vehicle;

  const feeAmount = calculateFeeAmount(price, totalFee);
  const sharedFeeAmount = calculateFeeAmount(price, sharedFee);

  return (
    <div className="flex flex-col gap-y-2 rounded-lg shadow-sm border border-gray-200 p-4 my-2">
      <div className="flex justify-between items-center">
        <Image
          src="/connect_logo_h.png"
          alt="Logo Movi Connect"
          width={115}
          height={34.5}
        />
        {negotiationStatus ? (
          <ConnectStatusBadge status={negotiationStatus} />
        ) : null}
      </div>
      <dl className="mt-2 grid grid-cols-2 gap-0.5 overflow-hidden rounded-2xl text-center sm:grid-cols-2 md:grid-cols-4 md:divide-x divide-x-gray-50">
        <div className="flex flex-col py-4 sm:p-6">
          <dt className="text-sm font-semibold leading-6 text-gray-600">
            Precio
          </dt>
          <dd className="order-first text-2xl sm:text-3xl font-semibold tracking-tight text-gray-900">
            {formatPrice(price, currency)}
          </dd>
        </div>

        <div className="flex flex-col py-4 sm:p-6">
          <dt className="text-sm font-semibold leading-6 text-gray-600">
            Precio mínimo
          </dt>
          <dd className="order-first text-2xl sm:text-3xl font-semibold tracking-tight text-gray-900">
            {minPrice ? formatPrice(minPrice, currency) : "-"}
          </dd>
        </div>

        <div className="flex flex-col py-4 sm:p-6">
          <dt className="text-sm font-semibold leading-6 text-gray-600">
            Comisión total
          </dt>
          <dd className="order-first text-2xl sm:text-3xl font-semibold tracking-tight text-gray-900">
            {totalFee ? `${totalFee}%` : "-"}{" "}
            <span className="text-gray-600 text-lg font-normal">
              {feeAmount ? `(${formatPrice(feeAmount, currency)})` : ""}
            </span>
          </dd>
        </div>

        <div className="flex flex-col py-4 sm:p-6">
          <dt className="text-sm font-semibold leading-6 text-gray-600">
            Compartido
          </dt>
          <dd className="order-first text-2xl sm:text-3xl font-semibold tracking-tight text-gray-900">
            {sharedFee ? `${sharedFee}%` : "-"}{" "}
            <span className="text-gray-600 text-lg font-normal">
              {sharedFeeAmount
                ? `(${formatPrice(sharedFeeAmount, currency)})`
                : ""}
            </span>
          </dd>
        </div>
      </dl>
      <div className="mt-3 pt-3 border-t border-t-gray-200">
        <p className="text-sm text-gray-500 mb-2">Compartir en redes</p>
        <ShareSection
          shareUrl={`${process.env.NEXT_PUBLIC_ROOT_URL}/autosusados/${vehicle.slug}`}
          originalSeller={vehicle.user}
        />
      </div>
    </div>
  );
}
